import React, { useState } from "react";

interface DisableUnitActions {
    disableRemove?: boolean;
    disableCopy?: boolean;
    disableClear?: boolean;
    hideExtraActions?: boolean;
}

interface DisableUnitActionsContext {
    disableUnitActions: DisableUnitActions | null;
    setDisableUnitActions: (actions: DisableUnitActions | null) => void;
}

interface DisableUnitActionsProviderProps {
    children: React.ReactNode;
}

export const DisableUnitActionsContext = React.createContext<DisableUnitActionsContext | null>(null);

export const DisableUnitActionsProvider = (props: DisableUnitActionsProviderProps) => {
    const [disableUnitActions, setDisableUnitActions] = useState<DisableUnitActions | null>(null);

    return (
        <DisableUnitActionsContext.Provider
            value={{ disableUnitActions: disableUnitActions, setDisableUnitActions: setDisableUnitActions }}>
            {props.children}
        </DisableUnitActionsContext.Provider>
    );
};
